import { request } from 'utils/requests'
import { cachedFetch, cacheClear, cacheDel } from 'utils/memoryCache'
import { CACHE_TTL } from 'utils/cacheTtl'

const NOTIFICATIONS_CACHE_KEY = 'notifications:list'
const NOTIFICATIONS_UNREAD_CACHE_KEY = 'notifications:unread-count'

const getNotificationsCacheKey = (params = {}) => {
  const serialized = JSON.stringify(params || {})
  return `${NOTIFICATIONS_CACHE_KEY}:${serialized}`
}

/**
 * Lista notificações do usuário logado
 */
export async function listNotifications(params = {}) {
  try {
    const cacheKey = getNotificationsCacheKey(params)
    return await cachedFetch(
      cacheKey,
      async () => request.get('/notifications', { params }),
      { ttlMs: CACHE_TTL.NOTIFICATIONS_LIST }
    )
  } catch (error) {
    console.error('Erro ao listar notificações:', error)
    throw error
  }
}

/**
 * Conta notificações não lidas
 */
export async function countUnreadNotifications() {
  try {
    return await cachedFetch(
      NOTIFICATIONS_UNREAD_CACHE_KEY,
      async () => request.get('/notifications/unread-count'),
      { ttlMs: CACHE_TTL.NOTIFICATIONS_COUNT }
    )
  } catch (error) {
    console.error('Erro ao contar notificações não lidas:', error)
    throw error
  }
}

/**
 * Marca notificação como lida
 */
export const markNotificationAsRead = async (notificationId) => {
  try {
    const response = await request.patch(`/notifications/${notificationId}/read`)
    cacheClear(NOTIFICATIONS_CACHE_KEY)
    cacheDel(NOTIFICATIONS_UNREAD_CACHE_KEY)
    return response
  } catch (error) {
    console.error('Erro ao marcar notificação como lida:', error)
    throw error
  }
}

/**
 * Deleta uma notificação
 */
export const deleteNotification = async (notificationId) => {
  try {
    const response = await request.delete(`/notifications/${notificationId}`)
    cacheClear(NOTIFICATIONS_CACHE_KEY)
    cacheDel(NOTIFICATIONS_UNREAD_CACHE_KEY)
    return response
  } catch (error) {
    console.error('Erro ao deletar notificação:', error)
    throw error
  }
}

/**
 * Cria notificação geral (apenas admin)
 */
export const createGeneralNotification = async (title, description, level = 'info') => {
  try {
    const response = await request.post('/notifications/general', {
      title,
      description,
      level
    })
    cacheClear(NOTIFICATIONS_CACHE_KEY)
    cacheDel(NOTIFICATIONS_UNREAD_CACHE_KEY)
    return response
  } catch (error) {
    console.error('Erro ao criar notificação geral:', error)
    throw error
  }
}

/**
 * Processa notificações agendadas manualmente (para testes)
 */
export const processScheduledNotifications = async () => {
  try {
    const response = await request.post('/notifications/process-scheduled')
    return response
  } catch (error) {
    console.error('Erro ao processar notificações agendadas:', error)
    throw error
  }
}
